/* eslint-disable @next/next/no-img-element */
import { forwardRef } from 'react'

const Author = ({ name, userId, avatar, role, bio, className }, ref) => {
  const _name = name || 'Pina'
  const _role = role || 'Content Writer'
  const _avatar = avatar ? avatar : '/assets/images/logo.png'

  return (
    <section ref={ref} className={`bg-gray-200 p-3 border border-transparent rounded-sm ${className}`}>
      <div className="flex flex-row flex-wrap items-center -mx-1">
        <div className="bg-white border border-gray-4 rounded-full overflow-hidden mx-1">
          <img src={_avatar} alt={name} className="h-12 w-12 p-2" />
        </div>
        <div className="mx-1">
          <p className="text-black text-base font-gotham-medium">{_name}</p>
          {_role && <p className="text-black text-sm font-gotham-book">{_role}</p>}
        </div>
      </div>
      {
        bio && 
        <div className="mt-2">
          <p className="text-black text-base font-gotham-book">{bio}</p>
        </div>
      }
    </section>
  )
}

export default forwardRef(Author)